import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const departmentsSlice = createSlice({
  name: "departments",
  initialState: {
    departments: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    fetchDepartmentsStart(state) {
      state.departments.loading = true;
      state.departments.error = null;
    },
    fetchDepartmentsSuccess(state, action) {
      state.departments.loading = false;
      state.departments.data = action.payload;
    },
    fetchDepartmentsFailure(state, action) {
      state.departments.loading = false;
      state.departments.error = action.payload;
    },
  },
});

export const {
  fetchDepartmentsStart,
  fetchDepartmentsSuccess,
  fetchDepartmentsFailure,
} = departmentsSlice.actions;

export const fetchDepartmentsData = () => async (dispatch) => {
  dispatch(fetchDepartmentsStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/getDepartmentUserPortal`
    );

    const data = response.data.data || [];
    dispatch(fetchDepartmentsSuccess(data));
  } catch (error) {
    console.error("API Error:", error);
    dispatch(fetchDepartmentsFailure(error.message || "Something went wrong"));
  }
};

export default departmentsSlice.reducer;
